module.exports = __webpack_public_path__ + "img/badge_previdenza_salute_main_level.634df406.jpg";